import React from 'react'
import './style.css'
import logo from '../mimecast-logo.svg'

import Details from "../details";
import {usePKCEAuthentication} from "../hooks/use-pkce-authentication";
import {AuthContext} from "../contexts/auth.context";


export const ReportPage = () => {
    const {isAuthenticated, error, loading, token, userInformation,action} = usePKCEAuthentication();

    return (<AuthContext.Provider value={{
        info: {
            token: token, userInformation: userInformation
        }
    }}>
        <div className='header'>
            <img style={{height: '21px'}} alt='Mimecast'
                 src={logo}/>
        </div>
        <main>
            <div className="container">
                {isAuthenticated &&
                    <div data-testid="details-element">
                        <Details action={action}></Details>
                    </div>
                }
                {loading && <div className='box'>
                    <div className="subtitle">Authenticating...</div>
                </div>}
                {error && <div className='box'>
                    <div className="title">{error.title}</div>
                    <div className="subtitle">{error.massage}</div>
                </div>}
            </div>
        </main>
    </AuthContext.Provider>)
}
